module.exports = __webpack_public_path__ + "static/firstSectionSecondaryaryImage-46c8a648a4d671f8f14718f0a7024001.jpeg";